module.exports = __webpack_public_path__ + "static/media/(V)_MG_6077_-_capim_dourado_-_bijuterias.5537efb7.jpg";